
import {ENGINE} from './engine'
import {ready,setBackend,getBackend} from './globals'
import logger from '@kemtai/logger';

export async function changeBackend(backend: string) {
    logger.event('tfjs-changeBackend', {
        backend: backend,
        level: 'webgl-log'
    });
    console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>> Changing TensorFlow.js backend to:', backend);
    (window as any)._kemtapi?.beforeContextRestart()

    ENGINE.reset();
    await setBackend(backend);
    await ready();
    // if (backend === 'wasm') {
    //     console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>> WASM threads count is:', getThreadsCount());
    // }
    (window as any)._kemtapi?.afterContextRestart()
    console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>> TensorFlow.js backend changed to:', getBackend());
    logger.event('tfjs-changeBackend-done', {
        backend: getBackend(),
        level: 'webgl-log'
    });
}

export async function resetBackend() {
    logger.event('tfjs-resetBackend', {
        backend: getBackend(),
        level: 'webgl-log'
    });

    (window as any)._kemtapi?.beforeContextRestart()
    
    console.log('tfjs: resetBackend - ENGINE.reset()');
    
    ENGINE.reset();
    await ready();


    console.log('tfjs: resetBackend - ENGINE.reset() - done' );
    logger.event('tfjs-resetBackend-done', {
        backend: getBackend(),
        level: 'webgl-log'
    });

    (window as any)._kemtapi?.afterContextRestart()
}